import { SponsorshipLayoutOutlet } from "@/features/sponsorship/components/layout/SponsorshipLayoutOutlet";
import {
  SPONSORSHIP_CONVERSIONS_PATH,
  SPONSORSHIP_HOW_IT_WORKS_PATH,
  SPONSORSHIP_PATH,
  SPONSORSHIP_RECOMMENDATIONS_PATH,
} from "@/features/sponsorship/constants/paths";
import type { RouteConfig } from "@/router/types";
import { lazyWithRetry } from "@/shared/utils/lazyWithRetry";

const SponsorshipOverviewPage = lazyWithRetry(() =>
  import("@/features/sponsorship/pages/SponsorshipOverviewPage").then((m) => ({ default: m.SponsorshipOverviewPage })),
);
const SponsorshipRecommendationsPage = lazyWithRetry(() =>
  import("@/features/sponsorship/pages/SponsorshipRecommendationsPage").then((m) => ({ default: m.SponsorshipRecommendationsPage })),
);
const SponsorshipConversionsPage = lazyWithRetry(() =>
  import("@/features/sponsorship/pages/SponsorshipConversionsPage").then((m) => ({ default: m.SponsorshipConversionsPage })),
);
const SponsorshipHowItWorksPage = lazyWithRetry(() =>
  import("@/features/sponsorship/pages/SponsorshipHowItWorksPage").then((m) => ({ default: m.SponsorshipHowItWorksPage })),
);

// Ré-exporté ici car importé par MainLayout (lien de navigation).
export { SPONSORSHIP_PATH } from "@/features/sponsorship/constants/paths";

const stripParent = (absolutePath: string): string =>
  absolutePath.startsWith(`${SPONSORSHIP_PATH}/`)
    ? absolutePath.slice(SPONSORSHIP_PATH.length + 1)
    : absolutePath;

const sponsorshipRoutes: RouteConfig[] = [
  {
    path: SPONSORSHIP_PATH,
    element: <SponsorshipLayoutOutlet />,
    isProtected: true,
    useMainLayout: true,
    children: [
      {
        index: true,
        element: <SponsorshipOverviewPage />,
        isProtected: false,
        useMainLayout: false,
      },
      {
        path: stripParent(SPONSORSHIP_RECOMMENDATIONS_PATH),
        element: <SponsorshipRecommendationsPage />,
        isProtected: false,
        useMainLayout: false,
      },
      {
        path: stripParent(SPONSORSHIP_CONVERSIONS_PATH),
        element: <SponsorshipConversionsPage />,
        isProtected: false,
        useMainLayout: false,
      },
      {
        path: stripParent(SPONSORSHIP_HOW_IT_WORKS_PATH),
        element: <SponsorshipHowItWorksPage />,
        isProtected: false,
        useMainLayout: false,
      },
    ],
  },
];

export default sponsorshipRoutes;
